<!--
  - Website: https://www.4myth.com
  - Email: mythpe@gmail.com
  - Mobile: +966590470092
  - Copyright © 2016-2022 All rights reserved.
  - MyTh Ahmed Fayez
  -->

<template>
  <div />
</template>

<script>

import { MetaInfoMixin } from '@mixins'

export default {
  name: 'HomePage',
  mixins: [MetaInfoMixin],
  data () {
    return {}
  },
  mounted () {
    if (this.authUser) {
      this.navigate(this.APP_ROUTES.user.home)
    }
  },
  methods: {}
}
</script>
